<template>
    <m-main-layout>
        <el-form :model="formData" :rules="rules" ref="form" label-width="150px">
            <el-form-item label="ID" v-if="formData.id">
                {{formData.id}}
            </el-form-item>
            <el-form-item :label="item.name" :prop="item.value" v-for="(item,index) in editParams" :class="item.type ==='editor' ? 'no-line-height' : ''">
                <template v-if="item.edit">
                    <type-select v-if="item.type === 'select'" v-model="formData[item.value]" @change="(e)=>$set(formData,item.value,e)" :options="item.options ? item.options : null" :data="item.data ? item.data : null" style="width: 500px;"></type-select>
                    <company-select v-else-if="item.type === 'company'" v-model="formData[item.value]" @change="(e)=>$set(formData,item.value,e)" style="width: 500px;"></company-select>
                    <vue-ueditor-wrap v-model="formData[item.value]" :config="config" :editor-id="editorId" v-else-if="item.type === 'editor'"></vue-ueditor-wrap>
<!--                    <editor v-model="formData[item.value]" ref="editor" v-else-if="item.type === 'editor'" style="width:100%;"/>-->
                    <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="formData[item.value]" v-else-if="item.type === 'textarea'" style="width: 500px;">
                    </el-input>
                    <head-img-upload v-model="formData.head_img" :img="formData.head_img ? $config.assetsUrl + formData.head_img : ''" v-else-if="item.value === 'head_img'" @change="(e)=>$set(formData,'head_img',e ? e : '')"></head-img-upload>
                    <head-img-upload v-model="formData[item.value]" :img="formData[item.value] ? $config.assetsUrl + formData[item.value] : ''" v-else-if="item.type === 'image'" @change="(e)=>$set(formData,item.value,e ? e : '')"></head-img-upload>
                    <push-time v-model="formData.todo_time" style="width: 500px;" v-else-if="item.value === 'todo_time'"></push-time>
                    <push-time v-model="formData.push_time" style="width: 500px;" v-else-if="item.value === 'push_time'"></push-time>
                    <push-time v-model="formData[item.value]" style="width: 500px;" v-else-if="item.type === 'time'"></push-time>
									<time-picker v-model="formData[item.value]" style="width: 500px;" v-else-if="item.type === 'timePick'"></time-picker>
                    <year-select v-model="formData.year" style="width: 500px;" v-else-if="item.value === 'year'"></year-select>
                    <file-upload v-model="formData.files_ids" v-else-if="item.type === 'file'" :files="formData['files']"></file-upload>
                    <el-switch
                        v-model="formData.state"
                        active-color="#13ce66"
                        :active-value="1"
                        :inactive-value="0"
                        active-text="启用"
                        inactive-text="禁用" v-else-if="item.type === 'state'">
                    </el-switch>
	                <el-switch
		                v-model="formData[item.value]"
		                active-color="#13ce66"
		                :active-value="1"
		                :inactive-value="0"
		                active-text="是"
		                inactive-text="否" v-else-if="item.type === 'bool'">
	                </el-switch>
                    <template v-else-if="item.type === 'totime'">
                        <el-input v-model="formData[item.value]" style="width: 400px;"></el-input>
                        <price-time-select class="margin-left" v-model="formData.time_type" style="width: 90px;"></price-time-select>
                    </template>
                    <group-select style="width: 500px;" v-else-if="item.type === 'group'" v-model="formData[item.value]"></group-select>
                    <el-input v-model="formData[item.value]" style="width: 500px;" v-else>
                        <template slot="prepend" v-if="item.prepend">{{item.prepend}}</template>
                        <template slot="append" v-if="item.append">{{item.append}}</template>
                    </el-input>
                    <template v-if="item.value === 'sort'">排序数字越小越靠前</template>
                    <template v-if="item.tip">{{item.tip}}</template>
                </template>
                <template v-else>
                    {{formData[item.value]}}
                </template>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('form')">保存</el-button>
                <el-button @click="$router.back()">返回</el-button>
            </el-form-item>
        </el-form>
    </m-main-layout>
</template>

<script>
export default {
    name: "PolicyEdit",
    data() {
        return {
            url:'',
            params:null,
            editParams:null,
            fileList: [],
            formData: {
                id: '',
            },
            routerData:null,
            rules: {},

            config: {
                // 编辑器不自动被内容撑高
                autoHeightEnabled: false,
                autoFloatEnabled:false,
                // 初始容器高度
                initialFrameHeight: 240,
                // 初始容器宽度
                initialFrameWidth: '100%',
                // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
                serverUrl: `${this.$config.editUrl}`,
                // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
                UEDITOR_HOME_URL: '/ueditor/'
            }
        };
    },
    created() {
        let _config = window.config.paths();
        let _path = this.$route.path.replace('/edit','');

        this.params = _config[_path];

        this.editParams = this.params['edit']['params'];
        this.routerData = this.params.routerData ? this.params.routerData : {};
        this.formData.id = this.$route.query.id ? this.$route.query.id : '';

        for(let i = 0;i<this.editParams.length;i++){
            this.rules[this.editParams[i].value] = [];
            // if(this.params[i].value === 'permission' || this.params[i].value === 'attachment') {
            //     this.$set(this.formData,this.params[i].value,[]);
            // }else{
            //     this.$set(this.formData,this.params[i].value,'');
            // }

            if(this.editParams[i].value === 'state'){
                this.$set(this.formData,this.editParams[i].value,1);
            }else if(this.editParams[i].value === 'sort'){
                this.$set(this.formData,this.editParams[i].value,0);
            }else{
                this.$set(this.formData,this.editParams[i].value,this.editParams[i].def ? this.editParams[i].def : '');
            }

						if(this.editParams[i].pattern){
							this.rules[this.editParams[i].value].push({message: '请填写正确的' + this.editParams[i].name, pattern: this.$regexp[this.editParams[i].pattern]});
						}else {
							if (this.editParams[i].type === 'price') {
								this.rules[this.editParams[i].value].push({message: '请填写正确的' + this.editParams[i].name, validator: this.$utils.rulePriceCanZero});
							} else if (this.editParams[i].type === 'totime') {
								this.rules[this.editParams[i].value].push({message: '请填写正确的' + this.editParams[i].name, validator: this.$utils.mustNumber});
							} else if (this.editParams[i].value === 'sort') {
								this.rules[this.editParams[i].value].push({message: '请填写正确的' + this.editParams[i].name, validator: this.$utils.must09});
							}
						}

            if(this.editParams[i].rq){
                this.rules[this.editParams[i].value].push({required: true, message: this.editParams[i].name + '必填'});
            }
        }
    },
    mounted() {
        // this.getTypeList();
        if(this.formData.id) {
            this.getDetail();
            this.url = this.params.apiUrl+'/edit';
        }else{
            this.url = this.params.apiUrl+'/add';
        }
        // this.getPermission();
    },
    methods: {
        getDetail() {
            let _this = this;
            this.$http.httpPost({
                url: this.params.apiUrl+'/detail',
                datas: { id: this.formData.id },
                success(res) {
                    _this.formData = res ? JSON.parse(JSON.stringify(res)) : null;

                    for(let i=0;i < _this.editParams.length;i++){
                        if(_this.editParams[i].isNull){
                            _this.formData[_this.editParams[i].value] = '';
                        }
                    }

                }
            });
        },
        create() {
            let _this = this;
            this.$http.httpPost({
                url: this.url,
                datas: {...this.formData,...this.routerData},
                success(res) {
                    _this.$utils.success('保存成功！');
                    _this.$router.back();
                }
            });
        },

      checkDemandNameExists(){
        let _this = this;
          this.$http.httpPost({
            url: 'admin/demandType/checkDemandNameExists',
            type:"json",
            datas:{demandName:this.formData.name, typeId:this.formData.id},
            success: (res) => {
              if(!res) {
                _this.create();
              }
            }
          });
        },

        submitForm(formName) {
            //存在回调的方法，因为回调外和回调内的作用域不一致，所以务必为 _this 复制 this，否则在回调中无法访问this对象
            let _this = this;
            console.log(this.formData);
            let akey = this.routerData.akey;
            //通过传递form表单ref名称，来调用表单的validate方法
            this.$refs[formName].validate(valid => {
                //为true时验证通过
                if (valid) {
                    if(akey == 'demand') {
                      _this.checkDemandNameExists()
                    } else {
                      _this.create();
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        }
    },
    computed: {
        // 计算属性的 getter
        editorId: function () {
            return this.$utils.randomWords();
        }
    }
};
</script>
